import { getComponent, getComponentPart } from "./common";

export default class PrintingDemand{
    private baseElement: HTMLElement;
    private continueButton: HTMLElement;
    private descriptionArea: HTMLTextAreaElement;
    private descriptionFormat: string;

    static componentName = 'PrintingDemand';

    private detailsTextAreaPartName = 'PrintingDetailsTextArea';
    private continueButtonPartName = 'ContinueButton';

    private positionNamePlaceholder = '##POSITION##';
    private technologyNamePlaceholder = '##TECHNOLOGY##';

    private nextAction: (demandText: string) => void;

    constructor(parentElement: HTMLElement, next: (demandText: string) => void){
        this.baseElement = getComponent(parentElement, PrintingDemand.componentName);
        this.nextAction = next;
        this.descriptionArea = getComponentPart(this.baseElement, this.detailsTextAreaPartName) as HTMLTextAreaElement;
        this.descriptionFormat = this.descriptionArea?.value;
        this.continueButton = getComponentPart(this.baseElement, this.continueButtonPartName);
        this.initContinueButton();
    }

    private initContinueButton() {
        this.continueButton && this.continueButton.addEventListener('click', (event: Event) => this.continue(event))
    }

    private continue(event: Event): void {
        event.preventDefault();
        const description = this.getDescription();
        description && this.nextAction && this.nextAction(description);

        // TODO: add validation messages
    }

    private getDescription(){
        return this.descriptionArea?.value;
    }

    public set(positionName: string, technologyName: string){
        const descriptionText = this.descriptionFormat?.replace(this.positionNamePlaceholder, positionName).replace(this.technologyNamePlaceholder, technologyName);
        this.descriptionArea.value = descriptionText;
    }
}
